var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-tile',{attrs:{"to":_vm.item.shortName,"disabled":_vm.disableNavPoint}},[_c('v-list-tile-action',[_c('v-icon',{class:_vm.item.cssClass},[_vm._v(_vm._s(_vm.item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),(_vm.showUsage)?_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.item.usage))]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a819bec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 117
// module chunks = 1